import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const summarizeText = createAsyncThunk(
    'textSummarization/summarizeText',
    async ({ text }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/summarize-text', 'POST', { text });
            // Check if the response contains an error
            if (response.error) {
                return rejectWithValue(response.message);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error summarizing text');
        }
    }
);

const textSummarizationSlice = createSlice({
    name: 'textSummarization',
    initialState: {
        summary: null, // Stores the generated summary
        originalLength: 0, // Length of original text
        summaryLength: 0, // Length of summary
        compressionRatio: 0, // Compression ratio percentage
        loading: false, // Indicates ongoing API call
        error: null, // Stores error messages
        note: null, // Stores any additional notes (e.g., fallback method used)
    },
    reducers: {
        clearSummary: (state) => {
            state.summary = null;
            state.originalLength = 0;
            state.summaryLength = 0;
            state.compressionRatio = 0;
            state.error = null;
            state.note = null;
        },
        updateSummary: (state, action) => {
            state.summary = action.payload.summary;
            state.originalLength = action.payload.original_length;
            state.summaryLength = action.payload.summary_length;
            state.compressionRatio = action.payload.compression_ratio;
            state.note = action.payload.note;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(summarizeText.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(summarizeText.fulfilled, (state, action) => {
                state.loading = false;
                state.summary = action.payload.summary;
                state.originalLength = action.payload.original_length;
                state.summaryLength = action.payload.summary_length;
                state.compressionRatio = action.payload.compression_ratio;
                state.note = action.payload.note || null;
            })
            .addCase(summarizeText.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

// Reusable selectors
export const selectSummary = (state) => state.textSummarizationSlice.summary;
export const selectOriginalLength = (state) => state.textSummarizationSlice.originalLength;
export const selectSummaryLength = (state) => state.textSummarizationSlice.summaryLength;
export const selectCompressionRatio = (state) => state.textSummarizationSlice.compressionRatio;
export const selectLoading = (state) => state.textSummarizationSlice.loading;
export const selectError = (state) => state.textSummarizationSlice.error;
export const selectNote = (state) => state.textSummarizationSlice.note;

export const { clearSummary, updateSummary } = textSummarizationSlice.actions;
export default textSummarizationSlice.reducer; 